export default __webpack_public_path__ + "assets/images/ed26340d9098a81e7f29872c7332f462.png";